/**
 * Full audio event surface (docs/dev_master_specs.md's Water Sort audio
 * section) — every `id` this game ever passes to `IGameContext['audio'].play()`.
 * This module owns no audio assets (the platform's `IAudioService`
 * implementation resolves ids to actual sound files); it exists so every
 * `play()` call site in `store/waterSortStore.ts` references one shared,
 * exhaustive union instead of ad hoc strings.
 */
export var WaterSortAudioId;
(function (WaterSortAudioId) {
    WaterSortAudioId["BOTTLE_SELECT"] = "watersort_bottle_select";
    WaterSortAudioId["POUR_START"] = "watersort_pour_start";
    /** WP-REF.8 — the sustained liquid bed, looped while the stream flows. */
    WaterSortAudioId["POUR_LOOP"] = "watersort_pour_loop";
    WaterSortAudioId["POUR_COMPLETE"] = "watersort_pour_complete";
    /** WP-POUR.9 — the tube lifting out of its slot (pour rig lift phase). */
    WaterSortAudioId["TUBE_PICKUP"] = "watersort_tube_pickup";
    /** WP-POUR.9 — the tube settling back into its slot (lower/bounce phase). */
    WaterSortAudioId["TUBE_PLACE"] = "watersort_tube_place";
    WaterSortAudioId["INVALID_MOVE"] = "watersort_invalid_move";
    WaterSortAudioId["BOTTLE_COMPLETE"] = "watersort_bottle_complete";
    WaterSortAudioId["LEVEL_COMPLETE"] = "watersort_level_complete";
    WaterSortAudioId["HINT_REVEAL"] = "watersort_hint_reveal";
    WaterSortAudioId["EXTRA_TUBE_ADD"] = "watersort_extra_tube_add";
    WaterSortAudioId["UNDO"] = "watersort_undo";
    WaterSortAudioId["RESET"] = "watersort_reset";
})(WaterSortAudioId || (WaterSortAudioId = {}));
